import { sheets } from 'less';
import XLSX from 'xlsx'
function exportToExcel(tableName,fileName,dataListTable){
    //excel数据导出
      var theTable = this.$refs[tableName];
      var columns = theTable.$options.propsData.columns
      var columnsWidth = []
      var filterVal = []
      var tHeader = {}
      columns.map(item => {
        if (item.key) {
          tHeader[item.key] = item.title
          columnsWidth.push(item.width)
        }
      })
      for(var i in tHeader) {
        filterVal.push(i)
      }
      const list = dataListTable?dataListTable:theTable.$options.propsData.data;
      var dataList = []
      list.map((item,index) => {
        var obj = {}
        for(var j in item) {
          filterVal.map(item1 => {
            if (j == item1) {
              obj[j] = item[j]
            }
          })
        }
        dataList.push(obj)  
      })
      dataList.unshift(tHeader)   //标题
      var workbook = XLSX.utils.book_new();
      var ws1 = XLSX.utils.json_to_sheet(dataList,{header: filterVal,skipHeader: true});
      ws1['!cols'] = []
      columnsWidth.forEach(item => {
        var obj ={wpx: 100}
        if (item) {
          obj.wpx = item
        }
        ws1['!cols'].push(obj)
        
      })
      !fileName ? fileName = 'sheet' : ''
      XLSX.utils.book_append_sheet(workbook, ws1, "Sheet1");
      XLSX.writeFile(workbook, `${fileName}.xlsx`); 
}



// function exportJsonToExcel(dataList, headList, fileName){
//     //excel数据导出
//     console.log(headList)
//     console.log(dataList,'dataList')
//     var ws = []
//     for (var i = 0; i< dataList.length ; i++) {
//       // debugger
//         ws.push(getJSONData(dataList[i],headList[i],dataList[i]))  
//         // console.log(ws,'ws')
//     }
//     jsonToSheet(ws,fileName)  // ws 傳入表數據的個數  fileName 文件名 
//   }
// function jsonToSheet(ws,fileName) {
//   var workbook = XLSX.utils.book_new();
//   var ws_name = ['Operation Hourly New Hire', 'DATACHANGE', 'MANUAL', 'CASHINCENTIVE', 'DEPENDENT', 'BANK', 'EMERGENCY'];
//   // for(var i = 0; i < ws.length; i++) {
//   //   ws_name.push('Sheet' + (i+1))
//   // }
//   for (var k = 0; k < ws_name.length; k++) {
//     workbook.SheetNames.push(ws_name[k])
//     workbook.Sheets[ws_name[k]] = ws[k]
//     }
//     console.log(workbook,'workbook')
//   // XLSX.utils.book_append_sheet(workbook);
//   !fileName ? fileName = 'sheet' : ''
//   XLSX.writeFile(workbook, `${fileName}.xlsx`); 
// }
// function getJSONData(dataList,filterVal,columnsWidth) {
//   console.log(filterVal,'filterVal')
//   var ws1 = XLSX.utils.json_to_sheet(dataList,{header: filterVal,skipHeader: true});
//   ws1['!cols'] = []
//   columnsWidth.forEach(item => {
//     var obj ={wpx: 500}
//     if (item.width) {
//       obj.wpx = item.width
//     }
//     ws1['!cols'].push(obj)
//   })
//   return ws1
// }

function exportJsonToExcel(tableNameList,fileName,dataListTable){
    //excel数据导出
      var ws = []
      for(var i in tableNameList){
        var theTable = this.$refs[tableNameList[i]];
        var columns = theTable.$options.propsData.columns
        var list =dataListTable?dataListTable:theTable.$options.propsData.data;
        var dataList = getTabData(columns,list).dataList
        var filterVal = getTabData(columns,list).filterVal
        var columnsWidth = getTabData(columns,list).columnsWidth
        ws.push(getJSONData(dataList,filterVal,columnsWidth)) 
      }
      jsonToSheet(ws,fileName)  // ws 傳入表數據的個數  fileName 文件名 
  }
function getTabData(columns,list) {
  var columnsWidth = []
  var filterVal = []
  var tHeader = {}
  columns.map(item => {
    if (item.key) {
      tHeader[item.key] = item.title
      columnsWidth.push(item.width)
    }
  })
  for(var i in tHeader) {
    filterVal.push(i)
  }
  var dataList = []
  list.map((item,index) => {
    var obj = {}
    for(var j in item) {
      filterVal.map(item1 => {
        if (j == item1) {
          obj[j] = item[j]
        }
      })
    }
    dataList.push(obj)
  })
  dataList.unshift(tHeader)
  return {dataList,filterVal,columnsWidth}
}
function jsonToSheet(ws,fileName) {
  var workbook = XLSX.utils.book_new();
  var ws_name = ['Operation Hourly New Hire', 'DATACHANGE', 'MANUAL', 'CASHINCENTIVE', 'DEPENDENT', 'BANK', 'EMERGENCY']
  // for(var i = 0; i < ws.length; i++) {
  //   ws_name.push('Sheet' + (i+1))
  // }
  for (var k = 0; k < ws_name.length; k++) {
    workbook.SheetNames.push(ws_name[k])
    workbook.Sheets[ws_name[k]] = ws[k]
    }
  // XLSX.utils.book_append_sheet(workbook);
  !fileName ? fileName = 'sheet' : ''
  XLSX.writeFile(workbook, `${fileName}.xlsx`); 
}
function getJSONData(dataList,filterVal,columnsWidth) {
  var ws1 = XLSX.utils.json_to_sheet(dataList,{header: filterVal,skipHeader: true});
  ws1['!cols'] = []
  columnsWidth.forEach(item => {
    var obj ={wpx: 100}
    if (item) {
      obj.wpx = item
    }
    ws1['!cols'].push(obj)
  })
  return ws1
}

export default {
  exportToExcel, exportJsonToExcel
}



// WEBPACK FOOTER //
// ./src/util/ExcelExport.js